const separatorFmt = new Intl.NumberFormat('en-US')
const currencyFmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
const percentFmt = new Intl.NumberFormat('en-US', { style: 'percent', maximumFractionDigits: 2 })

export default {
  separator: (value) => {
    return separatorFmt.format(value)
  },
  currency: (value) => {
    return currencyFmt.format(value)
  },
  percentage: (value) => {
    return percentFmt.format(value / 100)
  },
}
